import { Context, createContext } from 'react';

export interface IHelpContext {
  showHelpContextPanel: boolean;
  toggleShowHelpContextPanel: (valueSuccess: boolean) => void;
}

export const HelpContext: Context<IHelpContext> = createContext<IHelpContext>({} as IHelpContext);
